import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { GbGemeindeId } from 'app/core/amtlichebewertung-api';
import { EMPTY, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { catchError, tap } from 'rxjs/operators';
import { CapAlertService } from 'app/core/extension/exceptions/cap-alert.service';
import { PersonStammListEntryMeta, PersonstammpersonService, PersonStammSearchResponseMeta } from 'app/core/personstamm-api';
import { TableSortModel } from 'app/shared/tablesort/tableSortModel';
import { ComparatorService } from 'app/shared/services/comparator-service';
import { CapExceptionHandler } from 'app/core/extension/exceptions/cap-exception-handler';
import { ResolverValidationExceptionHandler } from '../../../../core/extension/exceptions/exception-handler-rule';
import { CapAlertLevel } from '../../../../core/extension/exceptions/cap-alert-level.enum';

@Injectable()
export class PersonStammSearchResolver {
  gemeindeId: GbGemeindeId;
  grundstueckNummer: string;
  grundstueckNummerZusatz: string;
  grundstueckNummer3: string;

  readonly GEMEINDE_ID_PARAMETER_NAME = 'gemeindeId';
  readonly GRUNDSTUECK_NUMMER_PARAMETER_NAME = 'nummer';
  readonly GRUNDSTUECK_NUMMER2_PARAMETER_NAME = 'nummer2';
  readonly GRUNDSTUECK_NUMMER3_PARAMETER_NAME = 'nummer3';

  tableSortModel = new TableSortModel<PersonStammListEntryMeta>('table', this.comparatorService);

  constructor(
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private comparatorService: ComparatorService,
    private personService: PersonstammpersonService,
    private exceptionHandler: CapExceptionHandler,
    private resolverValidationExceptionHandler: ResolverValidationExceptionHandler
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PersonStammSearchResponseMeta> {
    const request = route.queryParamMap.get('request');
    return this.loadData(request);
  }

  getGemeindeId(id: string): GbGemeindeId {
    return { id };
  }

  private loadData(lastSearchRequest): Observable<PersonStammSearchResponseMeta> {
    if (!lastSearchRequest) {
      return;
    }
    if (lastSearchRequest) {
      const request = JSON.parse(lastSearchRequest);
      return this.personService.searchStammPerson(request).pipe(
        tap((r) =>
          r.tooManyRecordsFound
            ? this.capAlertService.warning(this.translate.instant('zpv.MaximalResultWarning'), CapAlertLevel.CONTENT_HEADER, true)
            : null
        ),
        catchError((err) => this.handleError(err))
      );
    }
  }

  private handleError(err) {
    if (err.status === 502) {
      this.capAlertService.warning(this.translate.instant('zpvService.nichtVerfuegbar'), CapAlertLevel.CONTENT_HEADER);
      return EMPTY;
    } else if (err.status === 404) {
      this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), CapAlertLevel.CONTENT_HEADER);
      return EMPTY;
    } else if (this.resolverValidationExceptionHandler.errorHandled(err)) {
      return EMPTY;
    }
    this.exceptionHandler.handleError(err);
    return EMPTY;
  }
}
